export const dqn1Title = "Reinforcement Learning using DQN";
export const dqn1SubText = "";
export const dqn1Date = "";
export const dqn1Link = "/blog/dqn";

export const secTitle = "My first project: Smallest enclosing circle";
export const secSubText =
  "The following paragraph gives an idea of the given problem:";
export const secDate = "20/03/2022";
export const secLink = "/blog/sec";

export const firstTitle = "Welcome";
export const firstSubText = `Welcome to my personal site, this is my first post where I will introduce the site and myself. 
The idea for a personal website was already long in the making.After learning some...`;
export const firstDate = "19/03/2022";
export const firstLink = "/blog/prologue";
